import React from 'react';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../app/commonReducer';
import { Search } from '../../../common/mix-search/index';
import { connect } from 'react-redux';
import { changeIdHover, REDUCER_NAME } from '../canslim/reducer';

import ConstCommon from '../../../common/Const';

const mapStateToProps = state => {
  return {
    listSearch: state[COMMON_REDUCER_NAME].listOrganizationSearch,
    currentSearch: state[REDUCER_NAME].currentItemSearch,
  };
};

const mapDispatchToProps = {
  changeIdHover,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchHighlight);

function SearchHighlight(props) {
  const { listSearch, changeIdHover, currentSearch, disabled } = props;
  return (
    <Search
      disabled={disabled}
      listSearch={listSearch}
      listKeyFilter={[
        ConstCommon.listOrganization.TICKER,
        ConstCommon.listOrganization.ORGAN_SHORT_NAME,
      ]}
      currentSearch={currentSearch}
      clickItemSearch={changeIdHover}
      sortKey={'ticker'}
      enableSearchByTicker={true}
    />
  );
}
